<template>
  <v-layout row justify-center>
    <v-flex xs12>
          <div class="container-form px-3 py-3">
            <v-tabs
              slider-color="blue"
              grow
            >
              <v-tab
                key="Familia"
                ripple
              >{{ form.last_name }}
              </v-tab>
              <v-tab
                v-if="family_info[0].vinculada == 'No'"
                key="aditional-info"
                ripple
              >{{ $t(`admissions.titles.additional_info`) }}
              </v-tab>
              <v-tab
                v-if="family_info[0].vinculada == 'No'"
                key="recommendations"
                ripple
              >{{ $t(`admissions.titles.recommendations`) }}
              </v-tab>
              <v-tab v-for="(item, index) in family_info"
                :key="'info-aspirant-' + index"
                ripple
              >{{ item.first_name }}
              </v-tab>
              <v-tabs-items class="mt-3">
                <v-tab-item
                  key="Familia"
                >
                  <v-expansion-panel>
                    <v-expansion-panel-content
                      key="guardian1"
                    >
                      <template v-slot:header>
                        <v-card-title>
                          <h2 class="font-weight-regular">{{ form.guardian1_first_name + " " + form.guardian1_last_name }}</h2>
                        </v-card-title>
                      </template>
                      <v-card flat class="container-form-inner mb-3">
                        <v-card-text>
                          <v-layout row wrap mt-2>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian1_first_name')"
                                :error-messages="errors.collect('guardian1_first_name')"
                                v-model="form.guardian1_first_name"
                                name="guardian1_first_name"
                                v-validate="'required'"
                                @change="onChange('guardian1_first_name', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian1_last_name')"
                                :error-messages="errors.collect('guardian1_last_name')"
                                v-model="form.guardian1_last_name"
                                name="guardian1_last_name"
                                v-validate="'required'"
                                @change="onChange('guardian1_last_name', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.guardian1_relation')"
                                :items="kinship_options"
                                :error-messages="errors.collect('guardian1_relation')"
                                name="guardian1_relation"
                                v-model="form.guardian1_relation"
                                v-validate="'required'"
                                @change="onChange('guardian1_relation', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.doc_type')"
                                :items="document_options"
                                :error-messages="errors.collect('guardian1_document_type')"
                                name="guardian1_document_type"
                                v-model="form.guardian1_document_type"
                                v-validate="'required'"
                                @change="onChange('guardian1_document_type', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian1_id')"
                                :error-messages="errors.collect('guardian1_id')"
                                v-model="form.guardian1_id"
                                name="guardian1_id"
                                v-validate="'required'"
                                @change="onChange('guardian1_id', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <date-picker
                                :form="form"
                                :label="$t('admissions.form.expedition_date')"
                                :v-errors="errors"
                                v-model="guardian1_expedition_date"
                                name="guardian1_expedition_date"
                                v-validate="'required'"
                                @change="onChange('guardian1_expedition_date', $event)"
                              ></date-picker>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <date-picker
                                :form="form"
                                :label="$t('admissions.form.date_birth')"
                                :v-errors="errors"
                                v-model="guardian1_birth_date"
                                name="guardian1_birth_date"
                                v-validate="'required'"
                                @change="onChange('guardian1_birth_date', $event)"
                              ></date-picker>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-autocomplete
                                :form="form"
                                :items="countries"
                                :error-messages="errors.collect('guardian1_country_birth')"
                                :label="$t('register_form.country')"
                                v-model="form.guardian1_country_birth"
                                name="guardian1_country_birth"
                                v-validate="'required'"
                                @change="onChange('guardian1_country_birth', $event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-autocomplete
                                :form="form"
                                :items="statesToShow"
                                :error-messages="errors.collect('guardian1_state_birth')"
                                :label="$t('register_form.state')"
                                v-model="form.guardian1_state_birth"
                                name="guardian1_state_birth"
                                v-validate="'required'"
                                @change="onChange('guardian1_state_birth', $event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-autocomplete
                                :form="form"
                                :items="citiesToShow"
                                :error-messages="errors.collect('guardian1_city_birth')"
                                :label="$t('register_form.city')"
                                v-model="form.guardian1_city_birth"
                                name="guardian1_city_birth"
                                v-validate="'required'"
                                @change="onChange('guardian1_city_birth', $event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian1_email')"
                                :error-messages="errors.collect('guardian1_email')"
                                v-model="form.guardian1_email"
                                name="guardian1_email"
                                v-validate="'required|email'"
                                type="email"
                                @change="onChange('guardian1_email', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian1_cellphone')"
                                :error-messages="errors.collect('guardian1_cellphone')"
                                v-model="form.guardian1_cellphone"
                                name="guardian1_cellphone"
                                v-validate="'required'"
                                @change="onChange('guardian1_cellphone', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-radio-group
                                :form="form"
                                :label="$t('admissions.form.gender')"
                                :error-messages="errors.collect('guardian1_gender')"
                                v-model="form.guardian1_gender"
                                row
                                name="guardian1_gender"
                                v-validate="'required'"
                                @change="onChange('guardian1_gender', $event)"
                              >
                                <v-radio
                                  :label="$t('admissions.form.gender_options.m')"
                                  value="m"
                                  name="gender"
                                  :color="'primary'"
                                ></v-radio>
                                <v-radio
                                  :label="$t('admissions.form.gender_options.f')"
                                  value="f"
                                  name="gender"
                                  :color="'primary'"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.home_address')"
                                :error-messages="errors.collect('guardian1_address')"
                                v-model="form.guardian1_address"
                                name="guardian1_address"
                                v-validate="'required'"
                                @change="onChange('guardian1_address', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.religion')"
                                :items="religion_options"
                                :error-messages="errors.collect('guardian1_religion')"
                                name="guardian1_religion"
                                v-model="form.guardian1_religion"
                                v-validate="'required'"
                                @change="onChange('guardian1_religion', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.nationality')"
                                :items="nationality_options"
                                :error-messages="errors.collect('guardian1_nationality')"
                                name="guardian1_nationality"
                                v-model="form.guardian1_nationality"
                                v-validate="'required'"
                                @change="onChange('guardian1_nationality', $event)"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                      <v-card flat class="container-form-inner mb-3">
                        <v-card-title>
                          <h2 class="font-weight-regular">{{ $t('admissions.titles.professional_info') }}</h2>
                        </v-card-title>
                        <v-card-text>
                          <v-layout row wrap mt-2>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.profession')"
                                :error-messages="errors.collect('guardian1_profession')"
                                v-model="form.guardian1_profession"
                                name="guardian1_profession"
                                v-validate="'required'"
                                @change="onChange('guardian1_profession', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.employee')"
                                :items="options"
                                :error-messages="errors.collect('guardian1_employed')"
                                name="guardian1_employed"
                                v-model="form.guardian1_employed"
                                v-validate="'required'"
                                @change="onChange('guardian1_employed', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.independent')"
                                :items="options"
                                :error-messages="errors.collect('guardian1_independent')"
                                name="guardian1_independent"
                                v-model="form.guardian1_independent"
                                v-validate="'required'"
                                @change="onChange('guardian1_independent', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.ocupation')"
                                :error-messages="errors.collect('guardian1_ocupation')"
                                v-model="form.guardian1_ocupation"
                                name="guardian1_ocupation"
                                v-validate="'required'"
                                @change="onChange('guardian1_ocupation', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.position')"
                                :error-messages="errors.collect('guardian1_position')"
                                v-model="form.guardian1_position"
                                name="guardian1_position"
                                v-validate="'required'"
                                @change="onChange('guardian1_position', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.company_time')"
                                :error-messages="errors.collect('guardian1_time')"
                                v-model="form.guardian1_time"
                                name="guardian1_time"
                                placeholder="Años"
                                v-validate="'required'"
                                @change="onChange('guardian1_time', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.company')"
                                :error-messages="errors.collect('guardian1_company')"
                                v-model="form.guardian1_company"
                                name="guardian1_company"
                                v-validate="'required'"
                                @change="onChange('guardian1_company', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.company_contact')"
                                :error-messages="errors.collect('guardian1_company_contact')"
                                v-model="form.guardian1_company_contact"
                                name="guardian1_company_contact"
                                v-validate="'required'"
                                @change="onChange('guardian1_company_contact', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.phone_number')"
                                :error-messages="errors.collect('guardian1_company_number')"
                                v-model="form.guardian1_company_number"
                                name="guardian1_company_number"
                                v-validate="'required'"
                                @change="onChange('guardian1_company_number', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                label="Email"
                                :error-messages="errors.collect('guardian1_company_email')"
                                v-model="form.guardian1_company_email"
                                name="guardian1_company_email"
                                v-validate="'required'"
                                type="email"
                                @change="onChange('guardian1_company_email', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.website')"
                                :error-messages="errors.collect('guardian1_company_web')"
                                v-model="form.guardian1_company_web"
                                name="guardian1_company_web"
                                v-validate="'required'"
                                @change="onChange('guardian1_company_web', $event)"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                      <v-card flat class="container-form-inner mb-3 bg-transparent">
                        <v-card-text>
                          <v-layout row wrap align-center justify-center>
                            <v-flex xs12 lg2 px-1>
                              <div class="upload-picture">
                                <img v-if="form.guardian1_photo" :src="form.guardian1_photo" alt="No Picture">
                                <img v-else :src="`${appUrl}/storage/img/form-photo.png`" alt="No Picture">
                                <div class="upload">
                                  <div class="example-btn">
                                    <file-upload
                                      class="mb-2 v-btn theme--dark primary"
                                      accept="image/*"
                                      input-id="guardian1_photo"
                                      :size="1024 * 1024 * 5"
                                      v-model="guardian1_photo"
                                      @input-filter="inputFilter"
                                      v-validate="{ required: !form.guardian1_photo }"
                                      ref="upload1">
                                      +
                                    </file-upload>
                                  </div>
                                </div>
                              </div>
                            </v-flex>
                            <v-flex xs12 lg7 px-1>
                              <v-layout row wrap>
                                <v-flex xs12 lg5 px-1>
                                <div class="upload">
                                  <div class="example-btn">
                                    <file-upload
                                      class="mb-2 v-btn theme--dark primary"
                                      accept="application/pdf"
                                      input-id="guardian1_document"
                                      :size="1024 * 1024 * 5"
                                      v-model="guardian1_document"
                                      @input-filter="inputFilter"
                                      v-validate="{ required: !form.guardian1_document }"
                                      ref="upload2">
                                      +
                                    </file-upload>
                                    {{ $t('admissions.form.document') }} <a v-if="form.guardian1_document" :href="form.guardian1_document" target="_blank">Ver</a>
                                  </div>
                                </div>
                                </v-flex>
                                <v-flex xs12 lg7 px-1>
                                <div class="upload">
                                  <div class="example-btn">
                                    <file-upload
                                      class="mb-2 v-btn theme--dark primary"
                                      accept="application/pdf"
                                      input-id="guardian1_employment_letter"
                                      :size="1024 * 1024 * 5"
                                      v-model="guardian1_employment_letter"
                                      name="guardian1_employment_letter"
                                      @input-filter="inputFilter"
                                      v-validate="{ required: !form.guardian1_employment_letter && letterRequired() }"
                                      ref="upload3">
                                      +
                                    </file-upload>
                                    {{ $t('admissions.form.work_letter') }}: <a v-if="form.guardian1_employment_letter" :href="form.guardian1_employment_letter" target="_blank">Ver</a>
                                  </div>
                                </div>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                      <v-card flat class="container-form-inner mb-3">
                        <v-card-title>
                          <h2 class="font-weight-regular">{{ $t('admissions.titles.academic_info') }}</h2>
                        </v-card-title>
                        <v-card-text>
                          <v-layout row wrap mt-2>
                            <v-flex xs12 lg6 px-1>
                              <v-radio-group
                                :label="$t('admissions.form.guardian1_graduate')"
                                v-model="form.guardian1_graduate"
                                row
                                @change="onChange('guardian1_graduate', $event)"
                              >
                                <v-radio
                                  :label="$t('admissions.form.yesno_options.yes')"
                                  value="Si"
                                  name="guardian1_graduate"
                                  :color="'primary'"
                                ></v-radio>
                                <v-radio
                                  :label="$t('admissions.form.yesno_options.no')"
                                  value="No"
                                  name="guardian1_graduate"
                                  :color="'primary'"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field v-if="form.guardian1_graduate === 'Si'"
                                :form="form"
                                :error-messages="errors.collect('guardian1_date')"
                                v-model="form.guardian1_date"
                                :label="$t('admissions.form.guardian1_date')"
                                name="guardian1_date"
                                type="number"
                                v-validate="'required'"
                                @change="onChange('guardian1_date', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('guardian1_school')"
                                v-model="form.guardian1_school"
                                :label="$t('admissions.form.secondary_school')"
                                name="guardian1_school"
                                type="text"
                                v-validate="'required'"
                                @change="onChange('guardian1_school', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('guardian1_school_date')"
                                v-model="form.guardian1_school_date"
                                :label="$t('admissions.form.guardian1_date')"
                                name="guardian1_school_date"
                                type="number"
                                v-validate="'required'"
                                @change="onChange('guardian1_school_date', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('guardian1_college')"
                                v-model="form.guardian1_college"
                                :label="$t('admissions.form.university')"
                                name="guardian1_college"
                                type="text"
                                v-validate="'required'"
                                @change="onChange('guardian1_college', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('guardian1_college_date')"
                                v-model="form.guardian1_college_date"
                                :label="$t('admissions.form.guardian1_date')"
                                name="guardian1_college_date"
                                type="number"
                                v-validate="'required'"
                                @change="onChange('guardian1_college_date', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg12 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('guardian1_title')"
                                v-model="form.guardian1_title"
                                :label="$t('admissions.form.university_degree')"
                                name="guardian1_title"
                                type="text"
                                v-validate="'required'"
                                @change="onChange('guardian1_title', $event)"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content
                      key="guardian2"
                    >
                      <template v-slot:header>
                        <v-card-title>
                          <h2 class="font-weight-regular">{{ form.guardian2_first_name + " " + form.guardian2_last_name }}</h2>
                        </v-card-title>
                      </template>
                      <v-card flat class="container-form-inner mb-3">
                        <v-card-text>
                          <v-layout row wrap mt-2>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian2_first_name')"
                                :error-messages="errors.collect('guardian2_first_name')"
                                v-model="form.guardian2_first_name"
                                name="guardian2_first_name"
                                v-validate="'required'"
                                @change="onChange('guardian2_first_name', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian2_last_name')"
                                :error-messages="errors.collect('guardian2_last_name')"
                                v-model="form.guardian2_last_name"
                                name="guardian2_last_name"
                                v-validate="'required'"
                                @change="onChange('guardian2_last_name', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.guardian2_relation')"
                                :items="kinship_options"
                                :error-messages="errors.collect('guardian2_relation')"
                                name="guardian2_relation"
                                v-model="form.guardian2_relation"
                                v-validate="'required'"
                                @change="onChange('guardian2_relation', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.doc_type')"
                                :items="document_options"
                                :error-messages="errors.collect('guardian2_document_type')"
                                name="guardian2_document_type"
                                v-model="form.guardian2_document_type"
                                v-validate="'required'"
                                @change="onChange('guardian2_document_type', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian2_id')"
                                :error-messages="errors.collect('guardian2_id')"
                                v-model="form.guardian2_id"
                                name="guardian2_id"
                                v-validate="'required'"
                                @change="onChange('guardian2_id', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <date-picker
                                :form="form"
                                :label="$t('admissions.form.expedition_date')"
                                :v-errors="errors"
                                v-model="guardian2_expedition_date"
                                name="guardian2_expedition_date"
                                v-validate="'required'"
                                @change="onChange('guardian2_expedition_date', $event)"
                              ></date-picker>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <date-picker
                                :form="form"
                                :label="$t('admissions.form.date_birth')"
                                :v-errors="errors"
                                v-model="guardian2_birth_date"
                                name="guardian2_birth_date"
                                v-validate="'required'"
                                @change="onChange('guardian2_birth_date', $event)"
                              ></date-picker>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-autocomplete
                                :form="form"
                                :items="countries"
                                :error-messages="errors.collect('guardian2_country_birth')"
                                :label="$t('register_form.country')"
                                v-model="form.guardian2_country_birth"
                                name="guardian2_country_birth"
                                v-validate="'required'"
                                @change="onChange('guardian2_country_birth', $event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-autocomplete
                                :form="form"
                                :items="statesToShow2"
                                :error-messages="errors.collect('guardian2_state_birth')"
                                :label="$t('register_form.state')"
                                v-model="form.guardian2_state_birth"
                                name="guardian2_state_birth"
                                v-validate="'required'"
                                @change="onChange('guardian2_state_birth', $event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-autocomplete
                                :form="form"
                                :items="citiesToShow2"
                                :error-messages="errors.collect('guardian2_city_birth')"
                                :label="$t('register_form.city')"
                                v-model="form.guardian2_city_birth"
                                name="guardian2_city_birth"
                                v-validate="'required'"
                                @change="onChange('guardian2_city_birth', $event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian2_email')"
                                :error-messages="errors.collect('guardian2_email')"
                                v-model="form.guardian2_email"
                                name="guardian2_email"
                                v-validate="'required|email'"
                                type="email"
                                @change="onChange('guardian2_email', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian2_cellphone')"
                                :error-messages="errors.collect('guardian2_cellphone')"
                                v-model="form.guardian2_cellphone"
                                name="guardian2_cellphone"
                                v-validate="'required'"
                                @change="onChange('guardian2_cellphone', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-radio-group
                                :form="form"
                                :label="$t('admissions.form.gender')"
                                :error-messages="errors.collect('guardian2_gender')"
                                v-model="form.guardian2_gender"
                                row
                                name="guardian2_gender"
                                v-validate="'required'"
                                @change="onChange('guardian2_gender', $event)"
                              >
                                <v-radio
                                  :label="$t('admissions.form.gender_options.m')"
                                  value="m"
                                  name="gender"
                                  :color="'primary'"
                                ></v-radio>
                                <v-radio
                                  :label="$t('admissions.form.gender_options.f')"
                                  value="f"
                                  name="gender"
                                  :color="'primary'"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.home_address')"
                                :error-messages="errors.collect('guardian2_address')"
                                v-model="form.guardian2_address"
                                name="guardian2_address"
                                v-validate="'required'"
                                @change="onChange('guardian2_address', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.religion')"
                                :items="religion_options"
                                :error-messages="errors.collect('guardian2_religion')"
                                name="guardian2_religion"
                                v-model="form.guardian2_religion"
                                v-validate="'required'"
                                @change="onChange('guardian2_religion', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.nationality')"
                                :items="nationality_options"
                                :error-messages="errors.collect('guardian2_nationality')"
                                name="guardian2_nationality"
                                v-model="form.guardian2_nationality"
                                v-validate="'required'"
                                @change="onChange('guardian2_nationality', $event)"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                      <v-card flat class="container-form-inner mb-3">
                        <v-card-title>
                          <h2 class="font-weight-regular">{{ $t('admissions.titles.professional_info') }}</h2>
                        </v-card-title>
                        <v-card-text>
                          <v-layout row wrap mt-2>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.profession')"
                                :error-messages="errors.collect('guardian2_profession')"
                                v-model="form.guardian2_profession"
                                name="guardian2_profession"
                                v-validate="'required'"
                                @change="onChange('guardian2_profession', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.employee')"
                                :items="options"
                                :error-messages="errors.collect('guardian2_employed')"
                                name="guardian2_employed"
                                v-model="form.guardian2_employed"
                                v-validate="'required'"
                                @change="onChange('guardian2_employed', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.independent')"
                                :items="options"
                                :error-messages="errors.collect('guardian2_independent')"
                                name="guardian2_independent"
                                v-model="form.guardian2_independent"
                                v-validate="'required'"
                                @change="onChange('guardian2_independent', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian2_ocupation')"
                                :error-messages="errors.collect('guardian2_ocupation')"
                                v-model="form.guardian2_ocupation"
                                name="guardian2_ocupation"
                                v-validate="'required'"
                                @change="onChange('guardian2_ocupation', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.position')"
                                :error-messages="errors.collect('guardian2_position')"
                                v-model="form.guardian2_position"
                                name="guardian2_position"
                                v-validate="'required'"
                                @change="onChange('guardian2_position', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.company_time')"
                                :error-messages="errors.collect('guardian2_time')"
                                v-model="form.guardian2_time"
                                name="guardian2_time"
                                placeholder="Años"
                                v-validate="'required'"
                                @change="onChange('guardian2_time', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.guardian2_company')"
                                :error-messages="errors.collect('guardian2_company')"
                                v-model="form.guardian2_company"
                                name="guardian2_company"
                                v-validate="'required'"
                                @change="onChange('guardian2_company', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.company_contact')"
                                :error-messages="errors.collect('guardian2_company_contact')"
                                v-model="form.guardian2_company_contact"
                                name="guardian2_company_contact"
                                v-validate="'required'"
                                @change="onChange('guardian2_company_contact', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.phone_number')"
                                :error-messages="errors.collect('guardian2_company_number')"
                                v-model="form.guardian2_company_number"
                                name="guardian2_company_number"
                                v-validate="'required'"
                                @change="onChange('guardian2_company_number', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                label="Email"
                                :error-messages="errors.collect('guardian2_company_email')"
                                v-model="form.guardian2_company_email"
                                name="guardian2_company_email"
                                v-validate="'required'"
                                type="email"
                                @change="onChange('guardian2_company_email', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.website')"
                                :error-messages="errors.collect('guardian2_company_web')"
                                v-model="form.guardian2_company_web"
                                name="guardian2_company_web"
                                v-validate="'required'"
                                @change="onChange('guardian2_company_web', $event)"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                      <v-card flat class="container-form-inner mb-3 bg-transparent">
                        <v-card-text>
                          <v-layout row wrap align-center justify-center>
                            <v-flex xs12 lg2 px-1>
                              <div class="upload-picture">
                                <img v-if="form.guardian2_photo" :src="form.guardian2_photo" alt="No Picture">
                                <img v-else :src="`${appUrl}/storage/img/form-photo.png`" alt="No Picture">
                                <div class="upload">
                                  <div class="example-btn">
                                    <file-upload
                                      class="mb-2 v-btn theme--dark primary"
                                      accept="image/*"
                                      input-id="guardian2_photo"
                                      :size="1024 * 1024 * 5"
                                      v-model="guardian2_photo"
                                      @input-filter="inputFilter"
                                      v-validate="{ required: !form.guardian2_photo }"
                                      ref="upload4">
                                      +
                                    </file-upload>
                                  </div>
                                </div>
                              </div>
                            </v-flex>
                            <v-flex xs12 lg7 px-1>
                              <v-layout row wrap>
                                <v-flex xs12 lg5 px-1>
                                <div class="upload">
                                  <div class="example-btn">
                                    <file-upload
                                      class="mb-2 v-btn theme--dark primary"
                                      accept="application/pdf"
                                      input-id="guardian2_document"
                                      :size="1024 * 1024 * 5"
                                      v-model="guardian2_document"
                                      @input-filter="inputFilter"
                                      v-validate="{ required: !form.guardian2_document }"
                                      ref="upload5">
                                      +
                                    </file-upload>
                                    {{ $t('admissions.form.document') }} <a v-if="form.guardian2_document" :href="form.guardian2_document" target="_blank">Ver</a>
                                  </div>
                                </div>
                                </v-flex>
                                <v-flex xs12 lg7 px-1>
                                <div class="upload">
                                  <div class="example-btn">
                                    <file-upload
                                      class="mb-2 v-btn theme--dark primary"
                                      accept="application/pdf"
                                      input-id="guardian2_employment_letter"
                                      :size="1024 * 1024 * 5"
                                      v-model="guardian2_employment_letter"
                                      name="guardian2_employment_letter"
                                      @input-filter="inputFilter"
                                      v-validate="{ required: !form.guardian2_employment_letter && letterRequired() }"
                                      ref="upload6">
                                      +
                                    </file-upload>
                                    {{ $t('admissions.form.work_letter') }}: <a v-if="form.guardian2_employment_letter" :href="form.guardian2_employment_letter" target="_blank">Ver</a>
                                  </div>
                                </div>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                      <v-card flat class="container-form-inner mb-3">
                        <v-card-title>
                          <h2 class="font-weight-regular">{{ $t('admissions.titles.academic_info') }}</h2>
                        </v-card-title>
                        <v-card-text>
                          <v-layout row wrap mt-2>
                            <v-flex xs12 lg6 px-1>
                              <v-radio-group
                                :label="$t('admissions.form.guardian2_graduate')"
                                v-model="form.guardian2_graduate"
                                row
                                @change="onChange('guardian2_graduate', $event)"
                              >
                                <v-radio
                                  :label="$t('admissions.form.yesno_options.yes')"
                                  value="Si"
                                  name="guardian2_graduate"
                                  :color="'primary'"
                                ></v-radio>
                                <v-radio
                                  :label="$t('admissions.form.yesno_options.no')"
                                  value="No"
                                  name="guardian2_graduate"
                                  :color="'primary'"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field v-if="form.guardian2_graduate === 'Si'"
                                :form="form"
                                :error-messages="errors.collect('guardian2_date')"
                                v-model="form.guardian2_date"
                                :label="$t('admissions.form.guardian2_date')"
                                name="guardian2_date"
                                type="number"
                                v-validate="'required'"
                                @change="onChange('guardian2_date', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('guardian2_school')"
                                v-model="form.guardian2_school"
                                :label="$t('admissions.form.secondary_school')"
                                name="guardian2_school"
                                type="text"
                                v-validate="'required'"
                                @change="onChange('guardian2_school', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('guardian2_school_date')"
                                v-model="form.guardian2_school_date"
                                :label="$t('admissions.form.guardian2_date')"
                                name="guardian2_school_date"
                                type="number"
                                v-validate="'required'"
                                @change="onChange('guardian2_school_date', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('guardian2_college')"
                                v-model="form.guardian2_college"
                                :label="$t('admissions.form.university')"
                                name="guardian2_college"
                                type="text"
                                v-validate="'required'"
                                @change="onChange('guardian2_college', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('guardian2_college_date')"
                                v-model="form.guardian2_college_date"
                                :label="$t('admissions.form.guardian2_date')"
                                name="guardian2_college_date"
                                type="number"
                                v-validate="'required'"
                                @change="onChange('guardian2_college_date', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg12 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('guardian2_title')"
                                v-model="form.guardian2_title"
                                :label="$t('admissions.form.university_degree')"
                                name="guardian2_title"
                                type="text"
                                v-validate="'required'"
                                @change="onChange('guardian2_title', $event)"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content
                      key="payment_responsible"
                    >
                      <template v-slot:header>
                        <v-card-title>
                          <h2 class="font-weight-regular">{{ $t('admissions.form.payment_responsible') }}</h2>
                        </v-card-title>
                      </template>
                      <v-card flat class="container-form-inner mb-3">
                        <v-card-text>
                          <v-layout row wrap mt-2>
                            <v-flex xs12 lg4 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.payment_responsible')"
                                :items="responsible"
                                :error-messages="errors.collect('payment_responsible')"
                                v-model="form.payment_responsible"
                                name="payment_responsible"
                                v-validate="'required'"
                                @change="onChange('payment_responsible', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1 v-if="form.payment_responsible === 'Otro'">
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.doc_type')"
                                :items="document_options"
                                :error-messages="errors.collect('other_document_type')"
                                name="other_document_type"
                                v-model="form.other_document_type"
                                v-validate="'required'"
                                @change="onChange('other_document_type', $event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg4 px-1 v-if="form.payment_responsible === 'Otro'">
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.id')"
                                :error-messages="errors.collect('other_id')"
                                v-model="form.other_id"
                                name="other_id"
                                v-validate="'required'"
                                @change="onChange('other_id', $event)"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap v-if="form.payment_responsible === 'Otro'">
                            <v-flex xs12 lg4 px-1>
                              <date-picker
                                :form="form"
                                :label="$t('admissions.form.date_birth')"
                                :v-errors="errors"
                                v-model="other_birth_date"
                                name="other_birth_date"
                                v-validate="'required'"
                                @change="onChange('other_birth_date', $event)"
                              ></date-picker>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('other_first_name')"
                                v-model="form.other_first_name"
                                :label="$t('admissions.form.other_first_name')"
                                name="other_first_name"
                                v-validate="'required'"
                                @change="onChange('other_first_name', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('other_last_name')"
                                v-model="form.other_last_name"
                                :label="$t('admissions.form.other_last_name')"
                                name="other_last_name"
                                v-validate="'required'"
                                @change="onChange('other_last_name', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('other_cellphone')"
                                v-model="form.other_cellphone"
                                :label="$t('admissions.form.other_cellphone')"
                                name="other_cellphone"
                                v-validate="'required'"
                                @change="onChange('other_cellphone', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('other_email')"
                                v-model="form.other_email"
                                :label="$t('admissions.form.other_email')"
                                data-vv-name="other_email"
                                type="email"
                                v-validate="'required'"
                                @change="onChange('other_email', $event)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-autocomplete
                                :form="form"
                                :error-messages="errors.collect('other_country')"
                                :items="countries"
                                :label="$t('register_form.country')"
                                v-model="form.other_country"
                                name="other_country"
                                v-validate="'required'"
                                @change="onChange('other_country', $event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-autocomplete
                                :form="form"
                                :error-messages="errors.collect('other_state')"
                                :items="statesToShow3"
                                :label="$t('register_form.state')"
                                v-model="form.other_state"
                                name="other_state"
                                v-validate="'required'"
                                @change="onChange('other_state', $event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-autocomplete
                                :form="form"
                                :error-messages="errors.collect('other_city')"
                                :items="citiesToShow3"
                                :label="$t('register_form.city')"
                                v-model="form.other_city"
                                name="other_city"
                                v-validate="'required'"
                                @change="onChange('other_city', $event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 lg4 px-1>
                              <v-text-field
                                :form="form"
                                :error-messages="errors.collect('other_address')"
                                v-model="form.other_address"
                                :label="$t('admissions.form.other_address')"
                                name="other_address"
                                v-validate="'required'"
                                @change="onChange('other_address', $event)"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-tab-item>
                <v-tab-item
                  v-if="family_info[0].vinculada == 'No'"
                  key="aditional-info"
                >
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-text>
                      <v-layout row wrap mt-3>
                        <v-flex xs12 lg4 px-1>
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.first_language')"
                            :error-messages="errors.collect('first_language')"
                            v-model="form.first_language"
                            name="first_language"
                            v-validate="'required'"
                            @change="onChange('first_language', $event)"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg4 px-1>
                          <v-radio-group
                            v-model="form.family_tcs"
                            row
                            :label="$t('admissions.form.family_tcs')"
                            :error-messages="errors.collect('family_tcs')"
                            @change="onChange('family_tcs', $event)"
                            v-validate="'required'"
                            name="family_tcs"
                          >
                            <v-radio
                              :label="$t('admissions.form.yesno_options.yes')"
                              value="Si"
                              name="family_tcs"
                              :color="'primary'"
                            ></v-radio>
                            <v-radio
                              :label="$t('admissions.form.yesno_options.no')"
                              value="No"
                              name="family_tcs"
                              :color="'primary'"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                        <v-flex xs12 lg4 px-1>
                        </v-flex>
                        <v-flex xs12 lg4 px-1 v-if="form.family_tcs === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.full_name')"
                            :error-messages="errors.collect('Nombre')"
                            v-model="form.family_tcs_name1"
                            v-validate="'required'"
                            name="Nombre"
                            @change="onChange('family_tcs_name1', $event)"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg4 px-1 v-if="form.family_tcs === 'Si'">
                          <v-select
                            :form="form"
                            :label="$t('admissions.form.relation')"
                            :items="kinship_options"
                            :error-messages="errors.collect('relation')"
                            v-model="form.family_tcs_relation1"
                            v-validate="'required'"
                            name="relation"
                            @change="onChange('family_tcs_relation1', $event)"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 lg4 px-1 v-if="form.family_tcs === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.grade')"
                            :error-messages="errors.collect('Grado')"
                            v-model="form.family_tcs_grade1"
                            name="Grado"
                            @change="onChange('family_tcs_grade1', $event)"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg4 px-1 v-if="form.family_tcs === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.full_name')"
                            v-model="form.family_tcs_name2"
                            @change="onChange('family_tcs_name2', $event)"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg4 px-1 v-if="form.family_tcs === 'Si'">
                          <v-select
                            :form="form"
                            :label="$t('admissions.form.relation')"
                            :items="kinship_options"
                            v-model="form.family_tcs_relation2"
                            @change="onChange('family_tcs_relation2', $event)"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 lg4 px-1 v-if="form.family_tcs === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.grade')"
                            v-model="form.family_tcs_grade2"
                            @change="onChange('family_tcs_grade2', $event)"
                            type="text"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg4 px-1>
                          <v-radio-group
                            v-model="form.other_schools"
                            row
                            :label="$t('admissions.form.siblings_not_tcs')"
                            :error-messages="errors.collect('other_schools')"
                            @change="onChange('other_schools', $event)"
                            v-validate="'required'"
                            name="other_schools"
                          >
                            <v-radio
                              :label="$t('admissions.form.yesno_options.yes')"
                              value="Si"
                              name="other_schools"
                              :color="'primary'"
                            ></v-radio>
                            <v-radio
                              :label="$t('admissions.form.yesno_options.no')"
                              value="No"
                              name="other_schools"
                              :color="'primary'"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                        <v-flex xs12 lg8 px-1>
                        </v-flex>
                        <v-flex xs12 lg3 px-1 v-if="form.other_schools === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.full_name')"
                            :error-messages="errors.collect('Nombre')"
                            v-model="form.other_school_name1"
                            @change="onChange('other_school_name1', $event)"
                            v-validate="'required'"
                            name="Nombre"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg3 px-1 v-if="form.other_schools === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.grade')"
                            :error-messages="errors.collect('Grado')"
                            v-model="form.other_school_grade1"
                            @change="onChange('other_school_grade1', $event)"
                            name="Grado"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg3 px-1 v-if="form.other_schools === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.school')"
                            :error-messages="errors.collect('Colegio')"
                            v-model="form.other_school_school1"
                            @change="onChange('other_school_school1', $event)"
                            v-validate="'required'"
                            name="Colegio"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg3 px-1 v-if="form.other_schools === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('register_form.city')"
                            :error-messages="errors.collect('Ciudad')"
                            v-model="form.other_school_city1"
                            @change="onChange('other_school_city1', $event)"
                            v-validate="'required'"
                            name="Ciudad"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg3 px-1 v-if="form.other_schools === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.full_name')"
                            v-model="form.other_school_name2"
                            @change="onChange('other_school_name2', $event)"
                            name="Nombre"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg3 px-1 v-if="form.other_schools === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.grade')"
                            v-model="form.other_school_grade2"
                            @change="onChange('other_school_grade2', $event)"
                            name="Grado"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg3 px-1 v-if="form.other_schools === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.school')"
                            v-model="form.other_school_school2"
                            @change="onChange('other_school_school2', $event)"
                            name="Colegio"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg3 px-1 v-if="form.other_schools === 'Si'">
                          <v-text-field
                            :form="form"
                            :label="$t('register_form.city')"
                            v-model="form.other_school_city2"
                            @change="onChange('other_school_city2', $event)"
                            name="Ciudad"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg12 px-1>
                          <v-textarea
                            :form="form"
                            :error-messages="errors.collect('why_tcs')"
                            v-model="form.why_tcs"
                            :label="$t('admissions.form.important_factor')"
                            name="why_tcs"
                            v-validate="'required'"
                            @change="onChange('why_tcs', $event)"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-title>
                      <h2 class="font-weight-regular">{{ $t('admissions.titles.work_ref') }}</h2>
                    </v-card-title>
                    <v-card-text>
                      <v-layout v-for="(item, index) in work_references" row wrap mt-2 align-center justify-center :key="index">
                        <v-flex xs12 lg3 px-1>
                            <v-select
                              :form="form"
                              label="Acudiente"
                              :items="guardians"
                              v-model="work_references[index].guardian"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 lg3 px-1>
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.full_name')"
                            v-model="work_references[index].name"
                            type="text"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg2 px-1>
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.phone_number')"
                            v-model="work_references[index].phone"
                            type="text"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg3 px-1>
                          <v-text-field
                            :form="form"
                            label="Email"
                            v-model="work_references[index].email"
                            type="email"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg1 px-1 text-xs-center>
                          <v-icon v-if="item.id"
                            class="mr-1"
                            color="green"
                          >
                            check
                          </v-icon>
                        </v-flex>
                        <v-flex xs12 lg1 px-2 text-xs-center>
                          <v-btn color="primary" dark small @click="sendReference(work_references[index], index)">{{ $t('admissions.form.save') }}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-title>
                      <h2 class="font-weight-regular">{{ $t('admissions.titles.personal_ref') }}</h2>
                    </v-card-title>
                    <v-card-text>
                      <v-layout v-for="(item, index) in personal_references" row wrap mt-2 align-center justify-center :key="index">
                        <v-flex xs12 lg4 px-1>
                            <v-select
                              :form="form"
                              label="Acudiente"
                              :items="guardians"
                              v-model="personal_references[index].guardian"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 lg4 px-1>
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.full_name')"
                            v-model="personal_references[index].name"
                            type="text"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg4 px-1>
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.phone_number')"
                            v-model="personal_references[index].phone"
                            type="text"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg4 px-1>
                          <v-text-field
                            :form="form"
                            label="Email"
                            v-model="personal_references[index].email"
                            type="email"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg4 px-1>
                          <v-select
                            :form="form"
                            :label="$t('admissions.form.relation')"
                            :items="kinship_options"
                            v-model="personal_references[index].relation"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 lg4 px-1 text-xs-center>
                          <v-icon v-if="item.id"
                            class="mr-1"
                            color="green"
                          >
                            check
                          </v-icon>
                          <v-btn color="primary" dark small @click="sendReference(personal_references[index], index)">{{ $t('admissions.form.save') }}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  v-if="family_info[0].vinculada == 'No'"
                  key="recommendations"
                >
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-text v-html="$t('admissions.recommendation_text')"></v-card-text>
                  </v-card>

                  <v-card flat class="container-form-inner mb-3">
                    <v-card-title>
                      <h2 v-if="family_info[0].expatriado || family_info[0].multicultural" class="font-weight-regular">{{ $t('admissions.titles.tcs_rec') }}</h2>
                      <h2 v-else class="font-weight-regular">{{ $t('admissions.titles.recommendations') }}</h2>
                    </v-card-title>
                    <v-card-text>
                      <div v-if="family_info[0].expatriado || family_info[0].multicultural" v-html="$t('admissions.ext_recommendation_text')"></div>
                      <v-layout v-for="(item, index) in recommendations" row wrap mt-2 align-center :key="index">
                        <v-flex xs12 lg4 px-1>
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.full_name')"
                            v-model="recommendations[index].name"
                            type="text"
                            :readonly="item.submitted == 1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg2 px-1>
                          <v-text-field
                            :form="form"
                            :label="$t('admissions.form.phone_number')"
                            v-model="recommendations[index].cellphone"
                            type="text"
                            :readonly="item.submitted == 1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg4 px-1>
                          <v-text-field
                            :form="form"
                            label="Email"
                            v-model="recommendations[index].email"
                            type="email"
                            :readonly="item.submitted == 1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 lg2 px-1 text-xs-center>
                          <v-btn v-if="item.submitted == 1" color="success" dark small>{{ $t('admissions.form.received') }}</v-btn>
                          <v-btn v-else color="primary" dark small @click="sendRecommendation(recommendations[index], index)">{{ $t('admissions.form.send') }}</v-btn>
                        </v-flex>
                      </v-layout>
                      <div style="text-align: center;">
                          <v-btn color="primary" dark @click="addRecommendation()">Añadir recomendación</v-btn>
                        </div>
                      <div v-html="$t('admissions.recommendation_note')"></div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item v-for="(item, index) in family_info"
                  :key="'info-aspirant-' + index"
                >
                  <v-card flat class="container-form-inner mb-3">
                    <v-card-text>
                      <v-layout row wrap justify-end>
                        <v-flex xs12 lg4 px-1>
                          <div class="upload">
                            <div class="example-btn text-xs-right">
                              <file-upload
                                class="mb-2 v-btn theme--dark primary"
                                accept="application/pdf"
                                :input-id="'rc-' + index"
                                :size="1024 * 1024 * 5"
                                v-model="rc[item.id]"
                                @input-filter="inputFilter"
                                v-validate="{ required: !item.rc }"
                                :ref="'rc_' + item.id">
                                +
                              </file-upload>
                              {{ $t('admissions.form.document') }} <a v-if="item.rc" :href="item.rc" target="_blank">Ver</a>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12 lg3 px-1>
                          <div class="upload-picture">
                                <img v-if="item.photo" :src="item.photo" alt="No Picture">
                                <img v-else :src="`${appUrl}/storage/img/form-photo.png`" alt="No Picture">
                            <div class="upload">
                              <div class="example-btn">
                                <file-upload
                                  class="mb-2 v-btn theme--dark primary"
                                  accept="image/*"
                                  :input-id="'photo-' + index"
                                  :size="1024 * 1024 * 5"
                                  v-model="photo[item.id]"
                                  @input-filter="inputFilter"
                                  v-validate="{ required: !item.photo }"
                                  :ref="'photo_' + item.id + ''">
                                  +
                                </file-upload>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex xs12 lg9 px-1>
                          <v-layout row wrap>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :label="$t('admissions.form.first_name')"
                                :error-messages="errors.collect('first_name')"
                                v-model="item.first_name"
                                name="first_name"
                                v-validate="'required'"
                                @change="onChange2('first_name', $event, item.id)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :label="$t('admissions.form.last_name')"
                                :error-messages="errors.collect('last_name')"
                                v-model="item.last_name"
                                name="last_name"
                                v-validate="'required'"
                                @change="onChange2('last_name', $event, item.id)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <date-picker
                                :form="form"
                                :label="$t('admissions.form.date_of_birth')"
                                :v-errors="errors"
                                v-model="item.date_of_birth"
                                name="date_of_birth"
                                v-validate="'required'"
                                @change="onChange2('date_of_birth', $event, item.id)"
                              ></date-picker>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.place_of_birth')"
                                :error-messages="errors.collect('place_of_birth')"
                                v-model="item.place_of_birth"
                                name="place_of_birth"
                                v-validate="'required'"
                                @change="onChange2('place_of_birth', $event, item.id)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.doc_type')"
                                :items="document_options"
                                :error-messages="errors.collect('document_type')"
                                name="document_type"
                                v-model="item.document_type"
                                v-validate="'required'"
                                @change="onChange2('document_type', $event, item.id)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.nuip')"
                                :error-messages="errors.collect('nuip')"
                                v-model="item.nuip"
                                name="nuip"
                                v-validate="'required'"
                                @change="onChange2('nuip', $event, item.id)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-radio-group
                                :form="form"
                                :label="$t('admissions.form.gender')"
                                :error-messages="errors.collect('gender')"
                                v-model="item.gender"
                                row
                                name="gender"
                                v-validate="'required'"
                                @change="onChange2('gender', $event, item.id)"
                              >
                                <v-radio
                                  :label="$t('admissions.form.gender_options.m')"
                                  value="m"
                                  name="gender"
                                  :color="'primary'"
                                ></v-radio>
                                <v-radio
                                  :label="$t('admissions.form.gender_options.f')"
                                  value="f"
                                  name="gender"
                                  :color="'primary'"
                                ></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-text-field
                                :form="form"
                                :label="$t('admissions.form.home_address')"
                                :error-messages="errors.collect('address')"
                                v-model="item.address"
                                name="address"
                                v-validate="'required'"
                                @change="onChange2('address', $event, item.id)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.religion')"
                                :items="religion_options"
                                :error-messages="errors.collect('religion')"
                                name="religion"
                                v-model="item.religion"
                                v-validate="'required'"
                                @change="onChange2('religion', $event, item.id)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 lg6 px-1>
                              <v-select
                                :form="form"
                                :label="$t('admissions.form.nationality')"
                                :items="nationality_options"
                                :error-messages="errors.collect('nationality')"
                                name="nationality"
                                v-model="item.nationality"
                                v-validate="'required'"
                                @change="onChange2('nationality', $event, item.id)"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
            <v-card>
              <v-layout row justify-center align-center px-2>
                <v-checkbox
                  :form="form"
                  :error-messages="errors.collect('habeas')"
                  color="success"
                  name="habeas"
                  v-model="habeas"
                  v-validate="'required'"
                >
                  <div slot='label'>{{ $t('admissions.form.habeas') }} <strong><a :href="settings.habeas_data" target="_blank">{{ $t('admissions.form.habeas_link') }}</a></strong></div>
                </v-checkbox>
                <div v-if="family_info[family_info.length - 1 ].current_step === 5">
                    <v-btn color="primary" @click="goToNextStep(family_info[family_info.length - 1].current_step)" >{{ $t(`enrollments.go_to_step`) }} {{family_info[family_info.length - 1].current_step}}</v-btn>
                </div>
                <form v-else @submit.prevent="formValidation" @keydown="form.onKeydown($event)" id="admissions-form">
                  <v-btn
                    form="admissions-form"
                    type="submit"
                    color="primary"
                  >{{ $t(`enrollments.next`) }}</v-btn>
                </form>
                </v-layout>
            </v-card>
          </div>
    </v-flex>
  </v-layout>
</template>

<script>
import Form from 'vform'
import { mapGetters } from 'vuex'
import axios from 'axios'
import moment from 'moment';
import FileUpload from 'vue-upload-component'

export default {
  name: 'admissions_step1',
  components: {
    FileUpload,
  },
  metaInfo () {
    return { title: 'Formulario de Admisiones' }
  },
  props: {
    family: {
      type: [Array],
      required: true
    },
    settings: {
      type: [Object],
      required: true
    }
  },
  data () {
    return {
      appUrl: window.config.appUrl,
      dialog: false,
      dialogVerifyEmail: false,
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 50 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      form: new Form({
        vinculada: 'No',
        first_name: '',
        last_name: '',
        nuip: '',
        date_of_birth: '',
        gender: '',
        guardian1_first_name: '',
        guardian1_last_name: '',
        guardian1_document_type: '',
        guardian1_id: '',
        guardian1_expedition_date: '',
        guardian1_cellphone: '',
        guardian1_email: '',
        guardian1_relation: '',
        guardian1_profession: '',
        guardian1_ocupation: '',
        guardian1_company: '',
        guardian1_graduate: 'No',
        guardian1_date: '',
        guardian2_first_name: '',
        guardian2_last_name: '',
        guardian2_id: '',
        guardian2_cellphone: '',
        guardian2_email: '',
        guardian2_relation: '',
        guardian2_profession: '',
        guardian2_ocupation: '',
        guardian2_company: '',
        guardian2_graduate: 'No',
        guardian2_date: '',
        first_language: '',
        family_id: '',
        setting_id : '',
        guardian1_country_birth: '169',
        guardian2_country_birth: '169',
        other_country : '169'
      }),
      formVerification: new Form({
        code: '',
      }),
      eye: true,
      locales: [
        { value: 'en', text: 'EN' },
        { value: 'es', text: 'ES' }
      ],
      countries: [],
      states: [],
      cities: [],
      options: [
        {value: 'Si', text: this.$t('admissions.form.yesno_options.yes')},
        {value: 'No', text: this.$t('admissions.form.yesno_options.no')}
      ],
      kinship_options: [
        {value: 'Padre', text: this.$t('admissions.form.kinship_options.father')},
        {value: 'Madre', text: this.$t('admissions.form.kinship_options.mother')},
        {value: 'Abuelo', text: this.$t('admissions.form.kinship_options.grandfather')},
        {value: 'Abuela', text: this.$t('admissions.form.kinship_options.grandmother')},
        {value: 'Tío', text: this.$t('admissions.form.kinship_options.uncle')},
        {value: 'Tía', text: this.$t('admissions.form.kinship_options.aunt')},
        {value: 'Hermano', text: this.$t('admissions.form.kinship_options.brother')},
        {value: 'Hermana', text: this.$t('admissions.form.kinship_options.sister')},
        {value: 'Otro', text: this.$t('admissions.form.kinship_options.other')}
      ],
      document_options: [],
      religion_options: [],
      nationality_options: [],
      responsible: [
        {value: 'guardian1', text: 'Acudiente 1'},
        {value: 'guardian2', text: 'Acudiente 2'},
        {value: 'Otro', text: 'Otro'}
      ],
      guardians: [],
      countries: [],
      states: [],
      cities: [],
      meetings: [],
      disabled: true,
      verification_code: '',
      verification_target: '',
      confirm_code: '',
      registro_civil: [],
      registro_civil_twin: [],
      addressDialog: false,
      family_id: false,
      guardian1_photo: [],
      guardian1_document: [],
      guardian1_employment_letter: [],
      guardian2_photo: [],
      guardian2_document: [],
      guardian2_employment_letter: [],
      guardian1_expedition_date : "",
      guardian1_birth_date : "",
      guardian2_expedition_date : "",
      guardian2_birth_date : "",
      other_birth_date : "",
      date_of_birth : "",
      photo: [],
      rc: [],
      recommendations: [
        {id: null, name: '', cellphone: '', email: '', submitted: null},
        {id: null, name: '', cellphone: '', email: '', submitted: null},
        {id: null, name: '', cellphone: '', email: '', submitted: null}
      ],
      work_references: [
        {id: null, guardian: '', name: '', phone: '', email: '', relation: '', type: 'Work'},
        {id: null, guardian: '', name: '', phone: '', email: '', relation: '', type: 'Work'},
        {id: null, guardian: '', name: '', phone: '', email: '', relation: '', type: 'Work'}
      ],
      personal_references: [
        {id: null, guardian: '', name: '', phone: '', email: '', relation: '', type: 'Personal'},
        {id: null, guardian: '', name: '', phone: '', email: '', relation: '', type: 'Personal'},
        {id: null, guardian: '', name: '', phone: '', email: '', relation: '', type: 'Personal'}
      ],
      family_info: [],
      habeas : false,
    }
  },

  created () {
    this.form.locale = this.locale;
    this.init()
  },

  computed: {
    ...mapGetters({
      locale: 'locale'
    }),
    statesToShow() {
      return this.states.filter(state => state.id_pais === this.form.guardian1_country_birth)
    },
    statesToShow2() {
      return this.states.filter(state => state.id_pais === this.form.guardian2_country_birth)
    },
    statesToShow3() {
      return this.states.filter(state => state.id_pais === this.form.other_country)
    },
     citiesToShow() {
      return this.cities.filter(city => city.id_departamento == this.form.guardian1_state_birth  && city.f013_id_pais === this.form.guardian1_country_birth )
    },
    citiesToShow2() {
      return this.cities.filter(city => city.id_departamento == this.form.guardian2_state_birth && city.f013_id_pais === this.form.guardian2_country_birth) 
    },
    citiesToShow3() {
      return this.cities.filter(city => city.id_departamento === this.form.other_state)
    },
  },

  watch: {
    locale(newValue, oldValue) {
      this.form.locale = newValue
    },
    guardian1_expedition_date(newValue, oldValue) {
      const payload = {
          family_id : this.form.family_id,
          guardian1_expedition_date : newValue,
        }
      axios.put('/api/admissions/families', payload)
        .then(resp => {
          if (resp.status === 200) {
          }
        })
    },
    guardian1_birth_date(newValue, oldValue) {
      const payload = {
          family_id : this.form.family_id,
          guardian1_birth_date : newValue,
        }
      axios.put('/api/admissions/families', payload)
        .then(resp => {
          if (resp.status === 200) {
          }
        })
    },
    guardian2_expedition_date(newValue, oldValue) {
      const payload = {
          family_id : this.form.family_id,
          guardian2_expedition_date : newValue,
        }
      axios.put('/api/admissions/families', payload)
        .then(resp => {
          if (resp.status === 200) {
          }
        })
    },
    guardian2_birth_date(newValue, oldValue) {
      const payload = {
          family_id : this.form.family_id,
          guardian2_birth_date : newValue,
        }
      axios.put('/api/admissions/families', payload)
        .then(resp => {
          if (resp.status === 200) {
          }
        })
    },
    other_birth_date(newValue, oldValue) {
      const payload = {
          family_id : this.form.family_id,
          other_birth_date : newValue,
        }
      axios.put('/api/admissions/families', payload)
        .then(resp => {
          if (resp.status === 200) {
          }
        })
    },
    date_of_birth(newValue, oldValue) {
      const payload = {
          family_id : this.form.family_id,
          date_of_birth : newValue,
        }
      axios.put('/api/admissions/families', payload)
        .then(resp => {
          if (resp.status === 200) {
          }
        })
    },
    guardian1_photo() {
      let formData = new FormData();
      let fileData;
      this.guardian1_photo.forEach((file, index) => {
        fileData = this.$refs.upload1.get(file.id);
        formData.append(`file_${index}`, fileData.file);
      });
      formData.append('entry_id', this.form.id);
      formData.append('family_id', this.form.family_id);
      formData.append('field', 'guardian1_photo');
      axios.post('/api/admissions/save_file', formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(resp => {
          this.form.guardian1_photo = resp.data
        })
        .catch(err => {
          console.log(err.response)
        });
    },
    guardian1_document() {
      let formData = new FormData();
      let fileData;
      this.guardian1_document.forEach((file, index) => {
        fileData = this.$refs.upload2.get(file.id);
        formData.append(`file_${index}`, fileData.file);
      });
      formData.append('entry_id', this.form.id);
      formData.append('family_id', this.form.family_id);
      formData.append('field', 'guardian1_document');
      axios.post('/api/admissions/save_file', formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(resp => {
          this.form.guardian1_document = resp.data
        })
        .catch(err => {
          console.log(err.response)
        });
    },
    guardian1_employment_letter() {
      let formData = new FormData();
      let fileData;
      this.guardian1_employment_letter.forEach((file, index) => {
        fileData = this.$refs.upload3.get(file.id);
        formData.append(`file_${index}`, fileData.file);
      });
      formData.append('entry_id', this.form.id);
      formData.append('family_id', this.form.family_id);
      formData.append('field', 'guardian1_employment_letter');
      axios.post('/api/admissions/save_file', formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(resp => {
          this.form.guardian1_employment_letter = resp.data
        })
        .catch(err => {
          console.log(err.response)
        });
    },
    guardian2_photo() {
      let formData = new FormData();
      let fileData;
      this.guardian2_photo.forEach((file, index) => {
        fileData = this.$refs.upload4.get(file.id);
        formData.append(`file_${index}`, fileData.file);
      });
      formData.append('entry_id', this.form.id);
      formData.append('family_id', this.form.family_id);
      formData.append('field', 'guardian2_photo');
      axios.post('/api/admissions/save_file', formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(resp => {
          this.form.guardian2_photo = resp.data
        })
        .catch(err => {
          console.log(err.response)
        });
    },
    guardian2_document() {
      let formData = new FormData();
      let fileData;
      this.guardian2_document.forEach((file, index) => {
        fileData = this.$refs.upload5.get(file.id);
        formData.append(`file_${index}`, fileData.file);
      });
      formData.append('entry_id', this.form.id);
      formData.append('family_id', this.form.family_id);
      formData.append('field', 'guardian2_document');
      axios.post('/api/admissions/save_file', formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(resp => {
          this.form.guardian2_document = resp.data
        })
        .catch(err => {
          console.log(err.response)
        });
    },
    guardian2_employment_letter() {
      let formData = new FormData();
      let fileData;
      this.guardian2_employment_letter.forEach((file, index) => {
        fileData = this.$refs.upload6.get(file.id);
        formData.append(`file_${index}`, fileData.file);
      });
      formData.append('entry_id', this.form.id);
      formData.append('family_id', this.form.family_id);
      formData.append('field', 'guardian2_employment_letter');
      axios.post('/api/admissions/save_file', formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(resp => {
          this.form.guardian2_employment_letter = resp.data
        })
        .catch(err => {
          console.log(err.response)
        });
    },
    photo() {
      if (this.photo.length > 0) {
        let formData = new FormData();
        let fileData;
        let entryId;
        this.photo.forEach((file, index) => {
          if (file) {
            fileData = this.$refs['photo_' + index][0].get(file[0].id);
            formData.append(`file_0`, fileData.file);
            formData.append('entry_id', index);
            entryId = index;
          }
        });
        this.photo = []
        formData.append('family_id', this.form.family_id);
        formData.append('field', 'photo');
        axios.post('/api/admissions/save_file', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(resp => {
            this.family_info.forEach((entry, index) => {
              if (entry.id == entryId) {
                this.family_info[index].photo = resp.data
              }
            });
          })
          .catch(err => {
            console.log(err.response)
          });
      }
    },
    rc() {
      if (this.rc.length > 0) {
        let formData = new FormData();
        let fileData;
        let entryId;
        this.rc.forEach((file, index) => {
          if (file) {
            fileData = this.$refs['rc_' + index][0].get(file[0].id);
            formData.append(`file_0`, fileData.file);
            formData.append('entry_id', index);
            entryId = index;
          }
        });
        this.rc = []
        formData.append('family_id', this.form.family_id);
        formData.append('field', 'rc');
        axios.post('/api/admissions/save_file', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(resp => {
            this.family_info.forEach((entry, index) => {
              if (entry.id == entryId) {
                this.family_info[index].rc = resp.data
              }
            });
          })
          .catch(err => {
            console.log(err.response)
          });
      }
    }
  },

  methods: {
    async goToNextStep(step) {
      if (step != 5) {
        await this.updateStep(step)
      }
      this.$emit('goToNextStep', step, this.family_info)
    },
    async updateStep(step) {
      const payload = {
        entry_id : this.family_info[0].id,
        step : step
      }
      await axios.put('/api/admissions/update_step', payload)
        .then(resp => {
          if (resp.status === 200) {
            this.family_info[0] = resp.data.updated
          }
        })
    },
    init() {
      if (this.family.length > 0) {
        this.family_info = this.family
        axios.get('/api/countries')
          .then(resp => {
            if (resp.status === 200) {
              this.countries = resp.data.countries
            }
          })
          .catch(error => console.log(error))

        axios.get('/api/states')
          .then(resp => {
            if (resp.status === 200) {
              this.states = resp.data.states
            }
          })
          .catch(error => console.log(error))

        axios.get('/api/cities')
          .then(resp => {
            if (resp.status === 200) {
              this.cities = resp.data.cities
            }
          })
          .catch(error => console.log(error))

        axios.get('/api/admissions/general_options')
          .then(resp => {
            if (resp.status === 200) {
              this.document_options = resp.data.document_options
              this.nationality_options = resp.data.nationality_options
              this.religion_options = resp.data.religion_options
            }
          })
          .catch(error => console.log(error))

        this.family_id = this.family_info[0].family_id
        this.responsible = [
          {value: 'guardian1', text: this.family_info[0].guardian1_first_name + " " + this.family_info[0].guardian1_last_name},
          {value: 'guardian2', text: this.family_info[0].guardian2_first_name + " " + this.family_info[0].guardian2_last_name},
          {value: 'Otro', text: 'Otro'}
        ]
        this.guardians = [
          {value: this.family_info[0].guardian1_first_name + " " + this.family_info[0].guardian1_last_name, text: this.family_info[0].guardian1_first_name + " " + this.family_info[0].guardian1_last_name},
          {value: this.family_info[0].guardian2_first_name + " " + this.family_info[0].guardian2_last_name, text: this.family_info[0].guardian2_first_name + " " + this.family_info[0].guardian2_last_name}
        ]
        this.date_of_birth = this.family_info[0].date_of_birth
        this.other_birth_date = this.family_info[0].other_birth_date
        this.guardian1_expedition_date = this.family_info[0].guardian1_expedition_date
        this.guardian1_birth_date = this.family_info[0].guardian1_birth_date
        this.guardian2_expedition_date = this.family_info[0].guardian2_expedition_date
        this.guardian2_birth_date = this.family_info[0].guardian2_birth_date
        
        if (this.family_info[0].work_references.length > 0) {
          this.family_info[0].work_references.forEach(function (value, index) {
            this.work_references[index] = {'id': value.id, 'guardian': value.guardian, 'name': value.name, 'phone': value.phone, 'email': value.email, 'relation': value.relation}
          }, this);
        }
        
        if (this.family_info[0].personal_references.length > 0) {
          this.family_info[0].personal_references.forEach(function (value, index) {
            this.personal_references[index] = {'id': value.id, 'guardian': value.guardian, 'name': value.name, 'phone': value.phone, 'email': value.email, 'relation': value.relation}
          }, this);
        }
        
        if (this.family_info[0].recommendations.length > 0) {
          this.family_info[0].recommendations.forEach(function (value, index) {
            this.recommendations[index] = {'id': value.id, 'name': value.name, 'cellphone': value.cellphone, 'email': value.email, 'submitted': value.submitted}
          }, this);
        }
        
        if (this.family_info[0].current_step > 1 || this.family_info[0].current_step === 0) {
          this.habeas = true
        }

        this.form = new Form({
          id: this.family_info[0].id,
          vinculada: this.family_info[0].vinculada,
          first_name: this.family_info[0].first_name,
          last_name: this.family_info[0].last_name,
          nuip: this.family_info[0].nuip,
          gender: this.family_info[0].gender,
          place_of_birth: this.family_info[0].place_of_birth,
          document_type: this.family_info[0].document_type,
          address: this.family_info[0].address,
          religion: this.family_info[0].religion,
          nationality: this.family_info[0].nationality,
          guardian1_first_name: this.family_info[0].guardian1_first_name,
          guardian1_last_name:  this.family_info[0].guardian1_last_name,
          guardian1_id: this.family_info[0].guardian1_id,
          guardian1_cellphone: this.family_info[0].guardian1_cellphone,
          guardian1_email: this.family_info[0].guardian1_email,
          guardian1_relation: this.family_info[0].guardian1_relation,
          guardian1_profession: this.family_info[0].guardian1_profession,
          guardian1_ocupation: this.family_info[0].guardian1_ocupation,
          guardian1_company: this.family_info[0].guardian1_company,
          guardian1_graduate: this.family_info[0].guardian1_graduate,
          guardian1_date: this.family_info[0].guardian1_date,
          guardian2_first_name: this.family_info[0].guardian2_first_name,
          guardian2_last_name:  this.family_info[0].guardian2_last_name,
          guardian2_id: this.family_info[0].guardian2_id,
          guardian2_cellphone: this.family_info[0].guardian2_cellphone,
          guardian2_email: this.family_info[0].guardian2_email,
          guardian2_relation: this.family_info[0].guardian2_relation,
          guardian2_profession: this.family_info[0].guardian2_profession,
          guardian2_ocupation: this.family_info[0].guardian2_ocupation,
          guardian2_company: this.family_info[0].guardian2_company,
          guardian2_graduate: this.family_info[0].guardian2_graduate,
          guardian2_date: this.family_info[0].guardian2_date,
          first_language: this.family_info[0].first_language,
          family_tcs: this.family_info[0].family_tcs,
          other_schools: this.family_info[0].other_schools,
          why_tcs: this.family_info[0].why_tcs,
          family_tcs_name1: this.family_info[0].family_tcs_name1,
          family_tcs_relation1: this.family_info[0].family_tcs_relation1,
          family_tcs_grade1: this.family_info[0].family_tcs_grade1,
          family_tcs_name2: this.family_info[0].family_tcs_name2,
          family_tcs_relation2: this.family_info[0].family_tcs_relation2,
          family_tcs_grade2: this.family_info[0].family_tcs_grade2,
          other_school_name1: this.family_info[0].other_school_name1,
          other_school_grade1: this.family_info[0].other_school_grade1,
          other_school_school1: this.family_info[0].other_school_school1,
          other_school_city1: this.family_info[0].other_school_city1,
          other_school_name2: this.family_info[0].other_school_name2,
          other_school_grade2: this.family_info[0].other_school_grade2,
          other_school_school2: this.family_info[0].other_school_school2,
          other_school_city2: this.family_info[0].other_school_city2,
          payment_responsible: this.family_info[0].payment_responsible,
          other_first_name: this.family_info[0].other_first_name,
          other_last_name: this.family_info[0].other_last_name,
          other_cellphone: this.family_info[0].other_cellphone,
          other_email: this.family_info[0].other_email,
          other_id: this.family_info[0].other_id,
          other_document_type: this.family_info[0].other_document_type,
          other_country: this.family_info[0].other_country,
          other_state: this.family_info[0].other_state,
          other_city: this.family_info[0].other_city,
          other_address: this.family_info[0].other_address,
          rc: this.family_info[0].rc,
          photo : this.family_info[0].photo,
          family_id: this.family_info[0].family_id,
          setting_id : this.family_info[0].setting_id,
          guardian1_document_type: this.family_info[0].guardian1_document_type,
          guardian1_country_birth: this.family_info[0].guardian1_country_birth,
          guardian1_state_birth: this.family_info[0].guardian1_state_birth,
          guardian1_city_birth: this.family_info[0].guardian1_city_birth,
          guardian1_gender: this.family_info[0].guardian1_gender,
          guardian1_address: this.family_info[0].guardian1_address,
          guardian1_religion: this.family_info[0].guardian1_religion,
          guardian1_nationality: this.family_info[0].guardian1_nationality,
          guardian1_employed: this.family_info[0].guardian1_employed,
          guardian1_independent: this.family_info[0].guardian1_independent,
          guardian1_position: this.family_info[0].guardian1_position,
          guardian1_time:  this.family_info[0].guardian1_time,
          guardian1_company_contact: this.family_info[0].guardian1_company_contact,
          guardian1_company_number: this.family_info[0].guardian1_company_number,
          guardian1_company_email: this.family_info[0].guardian1_company_email,
          guardian1_company_web: this.family_info[0].guardian1_company_web,
          guardian1_photo: this.family_info[0].guardian1_photo,
          guardian1_document: this.family_info[0].guardian1_document,
          guardian1_employment_letter: this.family_info[0].guardian1_employment_letter,
          guardian1_school: this.family_info[0].guardian1_school,
          guardian1_school_date: this.family_info[0].guardian1_school_date,
          guardian1_college: this.family_info[0].guardian1_college,
          guardian1_college_date: this.family_info[0].guardian1_college_date,
          guardian1_title: this.family_info[0].guardian1_title,
          guardian2_document_type: this.family_info[0].guardian2_document_type,
          guardian2_country_birth: this.family_info[0].guardian2_country_birth,
          guardian2_state_birth: this.family_info[0].guardian2_state_birth,
          guardian2_city_birth: this.family_info[0].guardian2_city_birth,
          guardian2_gender: this.family_info[0].guardian2_gender,
          guardian2_address: this.family_info[0].guardian2_address,
          guardian2_religion: this.family_info[0].guardian2_religion,
          guardian2_nationality: this.family_info[0].guardian2_nationality,
          guardian2_employed: this.family_info[0].guardian2_employed,
          guardian2_independent: this.family_info[0].guardian2_independent,
          guardian2_position: this.family_info[0].guardian2_position,
          guardian2_time:  this.family_info[0].guardian2_time,
          guardian2_company_contact: this.family_info[0].guardian2_company_contact,
          guardian2_company_number: this.family_info[0].guardian2_company_number,
          guardian2_company_email: this.family_info[0].guardian2_company_email,
          guardian2_company_web: this.family_info[0].guardian2_company_web,
          guardian2_photo: this.family_info[0].guardian2_photo,
          guardian2_document: this.family_info[0].guardian2_document,
          guardian2_employment_letter: this.family_info[0].guardian2_employment_letter,
          guardian2_school: this.family_info[0].guardian2_school,
          guardian2_school_date: this.family_info[0].guardian2_school_date,
          guardian2_college: this.family_info[0].guardian2_college,
          guardian2_college_date: this.family_info[0].guardian2_college_date,
          guardian2_title: this.family_info[0].guardian2_title,
        })
      }

    },
    showAddressDialog() {
      this.addressDialog = true
    },
    close() {
      this.dialog = false
      this.dialogVerifyEmail = false
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    onChange(name, value) {
      const payload = {
          family_id : this.form.family_id,
          [name] : value,
        }
      axios.put('/api/admissions/families', payload)
        .then(resp => {
          if (resp.status === 200) {
            console.log("Updated")
          }
        })
    },
    onChange2(name, value, id) {
      const payload = {
          id : id,
          [name] : value,
        }
      axios.put('/api/admissions/entries', payload)
        .then(resp => {
          if (resp.status === 200) {
            console.log("Updated")
          }
        })
    },
    letterRequired() {
      if (this.family_info[0].vinculada == 'Si') {
        return false
      }
      if (this.family_info[0].family.employee) {
        return false
      }
      return true
    },
    async formValidation () {
      if (await this.formHasErrors()) {
        console.log(JSON.stringify(this.errors))
        return
      }
      if (!this.habeas) {
        this.$store.dispatch('responseMessage', {
            type: 'warning',
            text: this.$t('extracurriculares.pay_reserve.must_accept_terms_conditions'),
            modal: true
        })
        return
      }

      await axios.get('/api/admissions/get_admissions_info')
        .then(resp => {
          if (resp.status === 200) {
            this.family_info = resp.data

            if (this.family_info[0].recommendations.length > 0) {
              this.family_info[0].recommendations.forEach(function (value, index) {
                this.recommendations[index] = {'id': value.id, 'name': value.name, 'cellphone': value.cellphone, 'email': value.email, 'submitted': value.submitted}
              }, this);
            }
          }
        })

      if (this.family_info[0].vinculada == 'No') {
        let work_references = []
        work_references = this.work_references.filter(ref => ref.id === null)
        if (work_references.length > 0) {
            this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('admissions.work_ref_validation'),
                modal: true
            })
          return
        }

        let personal_references = []
        personal_references = this.personal_references.filter(ref => ref.id === null)
        if (personal_references.length > 0) {
            this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('admissions.personal_ref_validation'),
                modal: true
            })
          return
        }

        let recommendations = []
        recommendations = this.recommendations.filter(rec => rec.submitted === 1)
        if (recommendations.length < 2) {
            this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('admissions.recommendation_validation'),
                modal: true
            })
          return
        }
      }

      this.goToNextStep(2)

    },
    async sendRecommendation (recommendation, index) {
      const payload = {
          id : recommendation.id,
          name : recommendation.name,
          cellphone : recommendation.cellphone,
          email : recommendation.email,
          family_id : this.family_id,
          full_name : this.family_info[0].full_name
        }
      // Register the user.
      axios.post('/api/admissions/recommendation', payload)
        .then(resp => {
            if (resp.data.already_exists) {
              this.$store.dispatch('responseMessage', {
                  type: 'warning',
                  text: 'Ya se ha enviado una solicitud de recomendación a este correo.',
                  modal: true
              })
            } else if (resp.data.columbus_email)  {
              this.$store.dispatch('responseMessage', {
                  type: 'warning',
                  text: 'No se permiten correos con @columbus.edu.co',
                  modal: true
              })
              this.recommendations[index].id = resp.data.recommendation_id
            } else  {
              this.$store.dispatch('responseMessage', {
                  type: 'success',
                  text: 'Solicitud de recomendación enviada con éxito',
                  modal: true
              })
              this.recommendations[index].id = resp.data.recommendation_id
            }

        })
        .catch(err => {
          console.log(err.response)
        })
    },
    addRecommendation () {
      this.recommendations.push({id: null, name: '', cellphone: '', email: '', submitted: null});
    },
    async sendReference (reference, index) {
      const payload = {
          id : reference.id,
          guardian : reference.guardian,
          name : reference.name,
          phone : reference.phone,
          email : reference.email,
          relation : reference.relation,
          type : reference.type,
          family_id : this.family_id
        }
      // Register the user.
      axios.post('/api/admissions/reference', payload)
        .then(resp => {
          this.$store.dispatch('responseMessage', {
              type: 'success',
              text: 'Referencia guardada con éxito',
              modal: true
          })
          if (reference.type == 'Work') {
            this.work_references[index].id = resp.data.reference_id
          } else {
            this.personal_references[index].id = resp.data.reference_id
          }
        })
        .catch(err => {
          console.log(err.response)
        })
    },
  }
}
</script>

<style scoped>
  .container-form{
    background: #6198c8;
    border-radius: 16px;
    box-shadow: -6px 6px 6px #0000001A;
  }
  .container-form-inner{
    background: #F2F2F2;
    border-radius: 30px;
  }
  .container-form-inner .v-card__title, .v-expansion-panel__header .v-card__title{
    color: #004990;
    justify-content: center;
    background: #FFF;
  }
  .upload-picture {
    border-radius: 50%;
    background: #FFF;
    box-shadow: 0px 3px 6px #00000029;
    text-align: center;
    aspect-ratio: 1 / 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .upload-picture img{
    width: 100%;
    border-radius: 50%;
    height: 100%;
    object-fit: cover;
  }
  .upload-picture .example-btn{
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
  }
  .example-btn .v-btn {
    font-weight: lighter;
    line-height: 38px;
    width: 38px;
    height: 38px;
    font-size: 30px;
    border-radius: 50%;
    min-width: auto;
    padding: 0;
    cursor: pointer;
  }
  .v-expansion-panel {
    box-shadow: none;
  }
  .theme--light.v-expansion-panel .v-expansion-panel__container {
    background-color: transparent;
  }
  .v-expansion-panel__header .v-card__title{
    border-radius: 20px;
  }
  .bg-transparent {
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/admissions_step1.vue